import React from 'react'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateFormTestComponent } from '../../components/Officer/CreateFormTestComponent'
import { Footer } from "../../components/share/Footer";

export const CreateFormTestContainer = () => {
  const titleName = "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <CreateFormTestComponent />
      <Footer />
    </div>
  );
}
